import axios from "axios"
import { env } from '../constants'


/* GET HISTORY */
export const history = (token, page = 1) => {
    const uri = `${env.startpoint}niu-niu/history/list?page=${page}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    /* A request that never reached the server has no response at all — hand back a shape
       the caller can read instead of undefined, so `response.status` can never throw */
    return axios.get(uri, headers).then(response => response).catch(error => error.response ? error.response : { status: 0, data: null })
}
